import {Component, OnChanges, ElementRef, Output, EventEmitter, Input, ViewChild} from '@angular/core';

import {DefaultPackage, Package} from '../services/capd.model';
import { PackageService } from '../services/package.service';

declare var $: any;

@Component({
  selector: 'package-duplicate',
  templateUrl: './package-duplicate.component.html',
  // inputs: ['oldPak']
})

export class PackageDuplicateComponent implements OnChanges {
  @Output() listChange: EventEmitter<any> = new EventEmitter();
  // @ViewChild('modalDuplicatePackage', null) modalDuplicatePackage: ElementRef;

  @Input() oldPak: DefaultPackage;
  newPak: DefaultPackage = { _id: '', name: '', version: '', state: 'Unpublished' };
  versionError = false;

  constructor(private _service: PackageService,
              private el: ElementRef) { }

  /**
   * ngOnChanges is called every time the oldPak is changed; i.e, whenever you choose a new package to duplicate.
   * The big thing this does, besides set it to copy everything else about the old package,
   * is splitting the old version, incrementing the last digit by 1, and re-assembling the string.
   * This has some downsides-- for instance, it doesn't see a difference between version 1.00 and 1.0, making
   * them both 1.1-- but it works well for most cases.
   *
   * @func ngOnChanges
   */
  ngOnChanges() {
    const oldVersion = this.oldPak.version.split('.');
    oldVersion[oldVersion.length - 1] = (parseInt(oldVersion[oldVersion.length - 1], 10) + 1).toString();
    const newVersion = oldVersion.join('.');

    this.newPak.name = this.oldPak.name;
    this.newPak.version = newVersion;
    this.newPak.requiredNlpVersion = this.oldPak.requiredNlpVersion;
  }

  /**
   * This is called on every keyup in the "version" field. it removes alphabetical characters, leaving
   * only numbers and special characters.
   *
   * @func stripAlpha
   * @param {boolean} isVersion - true is the current field being edited is "Package version."
   */
  stripAlpha(isVersion: boolean) {
    if (isVersion) {
      this.newPak.version = this.newPak.version.replace(/[a-zA-Z]/g, '');
    }
    else{
      this.newPak.requiredNlpVersion = this.newPak.requiredNlpVersion.replace(/[a-zA-Z]/g, '');
    }
  }

  /**
   * Submits a duplicate package in the following way:
   * First, it gets a list of all packages
   * Then, it filters packages by matching their name to the duplicate request
   * Then, it filters that list by trying to match version
   * If it finds that package combination already exists, it returns an error
   * Otherwise, it sends the request to duplicate
   *
   * @func onSubmit
   */
  onSubmit() {
    this.versionError = false;

    this._service.getPackages()
      .then((packages: Package[]) => packages.filter(pak => pak.name === this.newPak.name)
        .filter(pak => pak.version === this.newPak.version))
      .then(packages => {
        if (packages.length > 0) { this.versionError = true; }
        else {
          this._service.duplicatePackage(this.newPak, this.oldPak)
            .then(() => {
              this.listChange.emit(this.newPak);
              $(this.el.nativeElement).find('#modal-duplicate-package').hide();
              // this.modalDuplicatePackage.nativeElement.classList.toggle("show");
            });
        }
      });
  }
}
